import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/my.jpeg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiOutlineTwitter } from "react-icons/ai";
import { SiGmail } from "react-icons/si";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            {/* <p className="home-about-body">
              I am a Full Stack Web Developer with{" "}
              <b className="purple">8 years</b> of experience. I am a{" "}
              <b className="purple">Javascript</b> enthusiast and always ready to
              learn new technologies and frameworks. I have a good knowledge of
              <b className="purple"> React.js, Node.js, Express.js, and MongoDB</b>
              I have also worked on <b className="purple">Python</b> and its frameworks like
              <b className="purple"> Django.</b> I have also worked on <b className="purple">Mobile Applications</b> using 
              <b className="purple"> React Native</b> and <b className="purple"> Swift</b> respectively.
              
              <br />
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas related to{" "}
                <b className="purple">
                  Deep Learning and Natural Launguage Processing.
                </b>
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i>
            </p> */}
            <p className="home-about-body">
  I am a passionate Full Stack Web Developer with <b className="purple">8 years</b> of experience, specializing in <b className="purple">JavaScript</b> and always eager to learn emerging technologies and frameworks. My expertise spans across key technologies like <b className="purple">React.js, Node.js, Express.js,</b> and <b className="purple">MongoDB</b>. I also have hands-on experience with <b className="purple">Python</b> and its robust frameworks like <b className="purple">Django</b>, as well as <b className="purple">Mobile Application Development</b> using <b className="purple">React Native</b> and <b className="purple">Swift</b>.

  <br /><br />

  My areas of interest include building innovative <i><b className="purple">Web Technologies and Products</b></i>, with a particular focus on <b className="purple">Deep Learning</b> and <b className="purple">Natural Language Processing</b>.

  <br /><br />

  Whenever possible, I channel my passion into developing products using <b className="purple">Node.js</b> and modern  <b className="purple">JavaScript</b> libraries and frameworks like <i><b className="purple">React.js</b></i> and <i><b className="purple">Next.js</b></i>, continuously striving to push the boundaries of web development.
</p>

          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img
                src={myImg}
                className="img-fluid"
                style={{ borderRadius: "50%" }}
                alt="avatar"
              />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Mrezagolbaba"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/mohamadreza-golbaba/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:m.reza.golbaba@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <SiGmail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
